// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  padding-left: 1rem !important;
  padding-right: 0.625rem !important;
  background-color: var(--text-secondary);
  height: 2rem !important;
}

.close-icon {
  color: #FFF;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-content {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  background-color: var(--text-secondary);
  margin-bottom: 0rem !important;
}

.modal-text {
  color: #FFF;
  text-align: left;
}
.modal-text app-icon {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

h1.modal-text {
  margin-top: 0px;
  font-weight: bold;
  font-size: 1.25rem;
  margin-right: 1.25rem;
  margin-bottom: 1.5rem;
}

p.modal-text {
  margin-top: 0rem !important;
  margin-bottom: 0rem;
  font-size: 0.875rem;
  margin-right: 1.25rem;
}

ion-content {
  --background: transparent;
  background-color: var(--text-secondary);
}

swiper-container {
  margin-bottom: 0px;
}

swiper-slide {
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  display: flex;
}

.modal-btn {
  margin-top: 1.25rem !important;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0rem;
  align-items: center !important;
  justify-content: center !important;
  display: flex;
  font-size: 0.813 !important;
}

.modal-swipe-btn {
  min-width: 8.438rem !important;
  height: 1.75rem !important;
  font-size: 0.813 !important;
  --ripple-color: transparent;
  --background-hover-opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/hidden-participants-warning/hidden-participants-warning.component.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,kCAAA;EACA,uCAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,6BAAA;EACA,8BAAA;EACA,uCAAA;EACA,8BAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;AACJ;AACI;EACE,mBAAA;EACA,oBAAA;AACN;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,uCAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kCAAA;EACA,aAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;AAAJ","sourcesContent":["header {\n    padding-left: 1rem !important;\n    padding-right: 0.625rem !important;\n    background-color: var(--text-secondary);\n    height: 2rem !important\n}\n\n.close-icon {\n    color: #FFF;\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n\n.modal-content {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n    background-color: var(--text-secondary);\n    margin-bottom: 0rem !important;\n}\n\n.modal-text {\n    color: #FFF;\n    text-align: left;\n\n    app-icon {\n      margin-left: 0.5rem;\n      margin-right: 0.5rem;\n    }\n}\n\nh1.modal-text {\n    margin-top: 0px;\n    font-weight: bold;\n    font-size: 1.25rem;\n    margin-right: 1.25rem;\n    margin-bottom: 1.5rem;\n}\n\np.modal-text {\n    margin-top: 0rem !important;\n    margin-bottom: 0rem;\n    font-size: 0.875rem;\n    margin-right: 1.25rem;\n}\n\nion-content {\n    --background: transparent;\n    background-color: var(--text-secondary);\n}\n\nswiper-container {\n    margin-bottom: 0px;\n}\n\nswiper-slide {\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex;\n}\n\n.modal-btn{\n    margin-top: 1.25rem !important;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0rem;\n    align-items: center !important;\n    justify-content: center !important;\n    display: flex;\n    font-size: 0.813 !important;\n}\n\n.modal-swipe-btn {\n    min-width: 8.438rem !important;\n    height:1.75rem !important;\n    font-size: 0.813 !important;\n    --ripple-color: transparent;\n    --background-hover-opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
